import { Outlet, createFileRoute } from "@tanstack/react-router";
import { AdminShell } from "@/features/admin/AdminShell";

// Parent layout for every /admin/* route. AdminShell handles auth gating +
// renders the global tabs nav; each child route owns its own page body.
export const Route = createFileRoute("/admin")({
  component: () => (
    <AdminShell>
      <Outlet />
    </AdminShell>
  ),
});
